import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on} from '@elements/dom-utils';


const selectors = {
    base: '.js-set-datepicker-range',
    rangeDatepickerFrom: '.js-set-datepicker-range__datepicker-from',
    rangeDatepickerTo: '.js-set-datepicker-range__datepicker-to',
    rangeDatepickerAltField: '.js-datepicker__alt-field',
};

export function init () {
    onFind(selectors.base, function (baseElement) {
        onFind(selectors.rangeDatepickerFrom, function (fromDatepicker) {
            let altField = findIn(selectors.rangeDatepickerAltField, fromDatepicker);
                on('change', function () {
                    let fromValue = altField.value;
                    let maxDate = new Date().toISOString();
                    let numberOfDays = getNumberOfDays(fromValue, maxDate);
                    if (numberOfDays <= 30) {
                      let datepickerTo =  findIn(selectors.rangeDatepickerTo, baseElement);
                      let altFieldTo = findIn(selectors.rangeDatepickerAltField, datepickerTo);
                        altFieldTo.value = maxDate;

                    }
                }, fromDatepicker);
        });
    });
}


function getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
}